import React from 'react';
import { useTranslation } from 'next-i18next';
import { match } from 'ts-pattern';
import { cn } from '@zep/utils';
import { SubscribePlan } from '../../../../../types';
import { Vector1 } from '../../../shared';
import { PlanIcon } from '../../shared/PlanIcon';
export const PlanTypeWithMaxCcu = (props: {
  planType: SubscribePlan;
  maxCcu: number;
}) => {
  const {
    t
  } = useTranslation(['subscription']);
  const {
    planType,
    maxCcu
  } = props;
  return <div className="flex items-center gap-[6px]" data-sentry-component="PlanTypeWithMaxCcu" data-sentry-source-file="PlanTypeWithMaxCcu.tsx">
      {match(props.planType).with('basic', () => <PlanIcon className="rounded-[5px] bg-gradient-to-r from-[#24B6EC] to-[#1DCFAF]" iconClassName="size-[12px]" />).with('pro', () => <PlanIcon className="rounded-[5px] bg-gradient-to-r from-[#588AFF] to-[#A572FF]" iconClassName="size-[12px]" />).otherwise(() => null)}
      <span className={cn('text-[15px] font-[700]', {
      'text-primary': planType === 'pro',
      'text-mintDark': planType === 'basic'
    })}>
        {planType.toUpperCase()}
      </span>
      <Vector1 data-sentry-element="Vector1" data-sentry-source-file="PlanTypeWithMaxCcu.tsx" />
      <span className={cn('text-body-1 font-[600]', {
      'text-primary': planType === 'pro',
      'text-mintDark': planType === 'basic'
    })}>
        {t('subscription:payment.complete.MaxCcuPerson', {
        ccu: maxCcu,
        defaultValues: '최대 {{ccu}}명'
      })}
      </span>
    </div>;
};